<template>
  <div>
    <header class="header">
      <div class="header-left">
        <a style="height: 52px; display: block"> </a>
      </div>
      <div class="top-right">
        <div class="user-login" v-if="$store.state.token">
          <a @click="$parent.goNav('/')">{{ $t('header.home') }}</a> &nbsp;|&nbsp;
          <a class="shiwan" @click="$parent.goNav('/mine/center')">{{ $store.state.userInfo.username ? $store.state.userInfo.username : '' }}</a>
          &nbsp;|&nbsp; <a @click="outLogin">{{ $t('header.Signout') }}</a>
        </div>
        <div class="user-login" v-else>
          <a @click="$parent.goNav('/')"
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit">{{ $t('header.home') }}</font></font
            ></a
          ><font style="vertical-align: inherit"
            ><font style="vertical-align: inherit"> &nbsp;| </font><font style="vertical-align: inherit">{{ $t('header.Notmember') }} </font></font
          ><a @click="$parent.goNav('/register')"
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit">{{ $t('header.register') }}</font></font
            ></a
          >
        </div>
      </div>

      <img style="margin-top: -55px" class="header-logo" src="/static/image/logo1-1.png" />
    </header>
    <div class="app-content view-slideup on">
      <div class="main_container">
        <div class="main_content layout_1200">
          <div class="content_block left">
            <div class="left_content_layout">
              <!--  onerror="this.src = '/static/image/logo.png'" -->
              <!-- <div class="logo"><img  src="/static/image/logo.png"></div> -->

              <div class="app_download_container">
                <div class="phone_pic_container">
                  <img src="/static/image/iphone_app.png" class="phone_2" />
                </div>
                <div class="app_download_link_container">
                  <div class="app_download_link_content">
                    <div class="title">{{ $t('app.delete') }}</div>
                    <div class="desc">{{ $t('app.iOS') }}</div>
                    <div class="qrcode_container">
                      <div><img :src="$store.state.appInfo.ios_download_qrcode" onerror="this.src = '/static/image/appurl.jpg'" /></div>
                      <div>
                        <div class="download_text">{{ $t('app.Scan') }}</div>
                        <div class="download_link">
                          <a :href="$store.state.appInfo.ios_download_url" target="_blank">{{ $store.state.appInfo.ios_download_url }}</a>
                        </div>
                      </div>
                    </div>
                    <div class="qrcode_container">
                      <!-- <div><img src="/static/image/qr_h5.svg"></div> -->
                      <div>
                        <div class="download_text">{{ $t('app.Direct') }}</div>
                        <div class="download_link">
                          <a :href="$store.state.appInfo.h5_url" target="_blank">{{ $store.state.appInfo.h5_url }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="content_block right">
            <div class="right_content_layout" style="color: #fff !important">
              <div class="title_menu">
                <div class="title">{{ $t('app.Installation') }}</div>
                <div class="link"><a class="active" data-id="ios">iOS</a></div>
                <div class="link"><a data-id="android">Android</a></div>
              </div>

              <div class="app_download_notice">{{ $t('app.Download') }}<br />{{ $t('app.cannot') }}</div>

              <div class="app_download_guide_container" id="ios">
                <div class="app_download_guide">{{ $t('app.ios1') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example.png" /></div>

                <div class="app_download_guide">{{ $t('app.ios2') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example1.png" /></div>

                <div class="app_download_guide">{{ $t('app.ios3') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example2.png" /></div>

                <div class="app_download_guide">{{ $t('app.ios4') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example3.png" /></div>

                <div class="app_download_guide">{{ $t('app.ios5') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example4.png" /></div>

                <div class="app_download_guide">{{ $t('app.ios6') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example5.png" /></div>

                <div class="app_download_guide">{{ $t('app.ios7') }}</div>
                <div class="app_download_guide_img" style="padding-bottom: 60px"><img src="/static/image/ios_alert_box_example6.png" /></div>
              </div>

              <div class="app_download_guide_container" id="android" style="display: none; overflow-y: auto; height: calc(100% - 65px - 74px)">
                <div class="app_download_guide">{{ $t('app.adr1') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example.png" /></div>

                <div class="app_download_guide">{{ $t('app.adr2') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/and_alert_box_example.png" /></div>

                <div class="app_download_guide">{{ $t('app.adr3') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/and_alert_box_example2.png" /></div>

                <div class="app_download_guide">{{ $t('app.adr4') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/and_alert_box_example3.png" /></div>

                <div class="app_download_guide">{{ $t('app.adr5') }}</div>
                <div class="app_download_guide_img"><img src="/static/image/and_alert_box_example4.png" /></div>

                <div class="app_download_guide">{{ $t('app.adr6') }}</div>
                <div class="app_download_guide_img" style="padding-bottom: 60px"><img src="/static/image/and_alert_box_example5.png" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="content">
        <div class="sponsors"></div>
        <div class="foot-nav">
          <div class="copyright all-rights">© 2022 {{ $store.state.appInfo.title }} {{ $t('foot.All') }}.</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activityInfo',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {
    outLogin() {
      let that = this;
      that.$parent.outLogin();
    },
  },
  mounted() {
    let that = this;
    $(function () {
      $('.title_menu .link a').click(function () {
        var thisData = $(this).data('id');
        $('.title_menu .link a').removeClass('active');
        $(this).addClass('active');

        $('.app_download_guide_container').slideUp(300);
        $('#' + thisData).slideDown(300);
      });
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../static/css/style.css';
@import '../../static/css/bootstrap.min.css';
@import '../../static/css/app.css';
html,
body {
  font-family: Arial, 'Microsoft JhengHei', sans-serif;
}
label {
  font-weight: 400;
}
.at-content {
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 99;
}
.at-mlu {
  height: 43px;
  color: rgb(255, 242, 155);
  font-size: 17px;
  line-height: 43px;
  width: 170px;
  text-align: center;

  background: url(/mb10/activity/img/xpj_prospirit.png) no-repeat 0px 0px;
  background-size: auto 43px;
}
.at-detail {
  margin: 10px 30px;
  line-height: 26px;
  color: rgb(51, 51, 51);
  font-size: 15px;
}
.at-font-red {
  color: red;
}
input {
  border-style: none;
}
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.box {
  position: relative;
  border-radius: 3px;
  background: #ffffff;
  border-top: 3px solid #e74c3c;
  margin-bottom: 20px;
  width: 100%;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  padding: 20px 5%;
  margin-top: 20px;
  width: 500px;
}
.logon-tab {
  color: #666;
  margin-bottom: 10px;
  font-size: 13px;
}
.controls {
  color: #666;
  font-size: 13px;
  margin-top: 15px;
}
.activity-image {
  height: 120px;
  width: auto;
  margin: 0 auto;
  margin-bottom: 12px;
}
@media screen and (max-width: 768px) {
  .at-detail {
    margin: 5px 10px;
  }
  .at-mlu {
    height: 35px;
    line-height: 35px;
    background-size: auto 35px;
    width: 140px;
    font-size: 14px;
  }
}

.table-bordered {
  margin-top: 10px;
}
.at-tr.at-font-red td {
  background: #f5f5f5;
  color: #999;
}
.at-tr {
  text-align: center;
}
.at-title {
  font-size: 30px;
  text-align: center;
  color: #333;
  margin-top: 15px;
}
@media screen and (max-width: 768px) {
  .at-tr td {
    font-size: 13px;
  }
  .at-title {
    font-size: 20px;
  }
  .box {
    width: 100%;
  }
}

.header-logo {
  width: auto;
  height: 55px;
  margin: -55px auto 0 auto;
  display: inherit;
}
.app-content {
  top: 90px;
}
.activity-content {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  background: #fff;
}
#result {
  font-size: 16px;
  color: #aaa;
}
.activity-sub {
  width: 100%;
  margin: 0 auto;
  border: 1px solid #ba924a;
  border-radius: 5px;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  display: -webkit-box;
}
.form-input {
  display: block;
  width: 100%;
  height: 34px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  color: #000;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  padding: 6px 12px;
}
.from-title {
  line-height: 40px;
  color: #ccc;
}
.form-btn {
  margin-top: 30px;
  line-height: 40px;
  height: 40px;
  border-radius: 3px;
  left: 50%;
  margin-left: -95px;
}
.form-group {
  -webkit-box-flex: 1;
  position: relative;
}
.free-demo {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  display: block;
  width: 190px;
  height: 44px;
  float: left;
  text-align: center;
  line-height: 44px;
  background: #cca352;
  position: relative;
  transition: all 0.2s;
  overflow: hidden;
}
.free-dem-a {
  color: #fff;
  font-size: 16px;
}
.free-demo:after {
  content: '';
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(-45deg);
  position: absolute;
  top: -10%;
  left: -100%;
  transition: 0.6s ease;
}
.free-demo:hover {
  background: #ba8d4d;
}
.free-demo:hover:after {
  animation: cv-submit-hover 0.8s ease;
}

@keyframes cv-submit-hover {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.group-content {
  width: 80%;
  max-width: 300px;
  position: absolute;
  right: 0;
}
.activity-image {
  margin-bottom: 5px;
}

.footer {
  margin-top: 100px;
}

html,
body {
  font-family: Arial, 'Microsoft JhengHei', sans-serif;
}
label {
  font-weight: 400;
}
.at-content {
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 99;
}
.at-mlu {
  height: 43px;
  color: rgb(255, 242, 155);
  font-size: 17px;
  line-height: 43px;
  width: 170px;
  text-align: center;
  background: url(/static/image/xpj_prospirit.png) no-repeat 0px 0px;
  background-size: auto 43px;
}
.at-detail {
  margin: 10px 30px;
  line-height: 26px;
  color: rgb(51, 51, 51);
  font-size: 15px;
}
.at-font-red {
  color: red;
}
input {
  border-style: none;
}
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.box {
  position: relative;
  border-radius: 3px;
  background: #ffffff;
  border-top: 3px solid #e74c3c;
  margin-bottom: 20px;
  width: 100%;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  padding: 20px 5%;
  margin-top: 20px;
  width: 500px;
}
.logon-tab {
  color: #666;
  margin-bottom: 10px;
  font-size: 13px;
}
.controls {
  color: #666;
  font-size: 13px;
  margin-top: 15px;
}

.activity-image {
  display: block;
}
.activity-image1 {
  display: none;
}

@media screen and (max-width: 768px) {
  .header-logo {
    display: none;
  }

  .app-content {
    top: 60px;
  }
  .image-back {
    top: 45px;
  }
  .activity-image1 {
    width: 100%;
    margin-bottom: 10px;
  }
  .footer {
    margin-top: 70px;
  }
  .at-detail {
    margin: 5px 10px;
  }
  .at-mlu {
    height: 35px;
    line-height: 35px;
    background-size: auto 35px;
    width: 140px;
    font-size: 14px;
  }
  .activity-image {
    display: none;
  }
  .activity-image1 {
    display: block;
  }
}
.right_content_layout[data-v-6c0a0fc1] {
  margin: 30px 0 0;
  background: #1f1f1f;
  -webkit-box-shadow: 0px 4px 15px rgb(0 0 0 / 10%);
  box-shadow: 0px 4px 15px rgb(0 0 0 / 10%);
  height: 779px;
  border-radius: 16px;
  padding: 48px 43px 10px;
  color: #fff;
}
.main_container[data-v-6c0a0fc1] {
  background: none;
}
.right_content_layout[data-v-6c0a0fc1][data-v-6c0a0fc1] {
  overflow: hidden;
}
.left_content_layout[data-v-6c0a0fc1] {
  margin: 59px 0 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/app.vue